import React from "react";
import Navigation from "./Navigation";
import Content from "./Content";

function Main() {
  return (
    <>
      <Navigation />
      <Content />
    </>
  );
}

export default Main;
